var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    {
      staticClass: "drop-shadow",
      style: { border: "none" },
      attrs: { "max-width": "560" },
    },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("title")) + " "),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              staticClass: "mls",
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-content",
        [
          _c("w-tabs", {
            style: { margin: "0 0 15px 2px" },
            attrs: { tabs: _vm.tabs },
            model: {
              value: _vm.activeTab,
              callback: function ($$v) {
                _vm.activeTab = $$v
              },
              expression: "activeTab",
            },
          }),
          _vm.activeTab == 0
            ? _c("div", { staticClass: "stats" }, [
                _c("div", { staticClass: "stat" }, [
                  _c("div", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$ct("balance"))),
                  ]),
                  _c("div", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.balance) + " "),
                    _c("span", { staticClass: "unit" }, [
                      _vm._v(_vm._s(_vm.$ct("ptn"))),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "stat" }, [
                  _c("div", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$ct("value"))),
                  ]),
                  _c("div", { staticClass: "value" }, [
                    _vm._v("€ " + _vm._s(_vm.balanceValue.toFixed(2))),
                  ]),
                ]),
                _c("div", { staticClass: "stat" }, [
                  _c("div", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$ct("this-document"))),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "value",
                      class: {
                        positive: _vm.earnPreview > 0,
                        negative: _vm.earnPreview < 0,
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.earnPreview > 0 ? "+" : "") +
                          _vm._s(_vm.earnPreview) +
                          " "
                      ),
                      _c("span", { staticClass: "unit" }, [
                        _vm._v(_vm._s(_vm.$ct("ptn"))),
                      ]),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
          _vm.activeTab == 0
            ? _c(
                "div",
                { staticClass: "progress-section mt" },
                [
                  _c(
                    "div",
                    { staticClass: "progress-labels" },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$ct("next-reward", {
                              points: _vm.nextRewardPoints,
                            })
                          )
                        ),
                      ]),
                      _c("w-spacer"),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$ct("points-to-go", { points: _vm.pointsToGo })
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c("w-progress-linear", {
                    attrs: { value: _vm.progress, color: "var(--main-blue-3)" },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.activeTab == 0 && _vm.cardBarcode
            ? _c(
                "div",
                { staticClass: "show-card-section mt" },
                [
                  _c(
                    "w-button",
                    {
                      attrs: {
                        block: "",
                        icon: "barcode",
                        loading: _vm.loadingCard,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.openCard()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$ct("show-card")) + " ")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.activeTab == 0 && _vm.redeemAllowed
            ? [
                _c("div", { staticClass: "redeem-section mt" }, [
                  _c("b", [_vm._v(_vm._s(_vm.$ct("redeem-as-discount")))]),
                  _c(
                    "div",
                    { staticClass: "redeem-options" },
                    _vm._l(_vm.redeemOptions, function (option) {
                      return _c(
                        "w-chip",
                        {
                          key: option,
                          class: { disabled: option > _vm.maxRedeemPoints },
                          attrs: {
                            clickable: option <= _vm.maxRedeemPoints,
                            active: _vm.redeemPoints == option,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.selectRedeemPoints(option)
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(option) +
                              " " +
                              _vm._s(_vm.$ct("ptn")) +
                              " "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                  _vm.saleRedeemPoints < _vm.balanceRedeemPoints
                    ? _c("div", { staticClass: "redeem-hint" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$ct("discount-limited", {
                                amount: (
                                  _vm.maxRedeemPoints * _vm.pointValue
                                ).toFixed(2),
                              })
                            ) +
                            " "
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]
            : _vm._e(),
          _vm.activeTab == 1
            ? _c("div", { staticClass: "history-section" }, [
                _c("div", { staticClass: "history-list" }, [
                  _vm.transactions.length > 0
                    ? _c(
                        "table",
                        _vm._l(_vm.transactions, function (transaction) {
                          return _c("tr", { key: transaction.ID }, [
                            _c("td", [
                              _vm._v(
                                _vm._s(_vm.printDate(transaction.TimeCreated))
                              ),
                            ]),
                            _c("td", [
                              _vm._v(_vm._s(_vm.formatDocument(transaction))),
                            ]),
                            _c(
                              "td",
                              {
                                staticClass: "points",
                                class: {
                                  positive: transaction.Points > 0,
                                  negative: transaction.Points < 0,
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(transaction.Points > 0 ? "+" : "") +
                                    _vm._s(transaction.Points) +
                                    " " +
                                    _vm._s(_vm.$ct("ptn")) +
                                    " "
                                ),
                              ]
                            ),
                          ])
                        }),
                        0
                      )
                    : _c("div", { staticClass: "empty" }, [
                        _vm._v(_vm._s(_vm.$ct("no-transactions"))),
                      ]),
                ]),
                _vm.isAdmin
                  ? _c(
                      "div",
                      { staticClass: "manual-row" },
                      [
                        _c("w-input-number", {
                          staticClass: "manual-input",
                          attrs: {
                            decimals: 0,
                            label: _vm.$ct("manual-points"),
                            fancy: "",
                          },
                          model: {
                            value: _vm.manualPoints,
                            callback: function ($$v) {
                              _vm.manualPoints = $$v
                            },
                            expression: "manualPoints",
                          },
                        }),
                        _c(
                          "w-button",
                          {
                            attrs: {
                              disabled: _vm.manualPoints == 0 || _vm.saving,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.addManualPoints()
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$ct("manual-add")) + " ")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ],
        2
      ),
      _vm.activeTab == 0 && _vm.redeemAllowed
        ? _c(
            "w-card-actions",
            [
              _c("div", [
                _vm._v(_vm._s(_vm.$ct("discount")) + ": "),
                _c("b", [_vm._v("€ " + _vm._s(_vm.discount.toFixed(2)))]),
              ]),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { icon: "check", disabled: _vm.redeemPoints <= 0 },
                  on: {
                    click: function ($event) {
                      return _vm.redeem()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("apply")) + " ")]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.showCard,
            callback: function ($$v) {
              _vm.showCard = $$v
            },
            expression: "showCard",
          },
        },
        [
          _c(
            "w-card",
            {
              staticClass: "drop-shadow",
              style: { border: "none" },
              attrs: { "max-width": "420" },
            },
            [
              _c(
                "w-card-title",
                [
                  _vm._v(" " + _vm._s(_vm.$ct("card-title")) + " "),
                  _c("w-spacer"),
                  _c(
                    "w-link",
                    {
                      staticClass: "mls",
                      attrs: { white: "" },
                      on: {
                        click: function ($event) {
                          _vm.showCard = false
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "times" } })],
                    1
                  ),
                ],
                1
              ),
              _c("w-card-content", [
                _c("div", { staticClass: "card-view" }, [
                  _vm.cardImageUrl
                    ? _c("img", {
                        staticClass: "card-barcode",
                        attrs: { src: _vm.cardImageUrl, alt: "" },
                      })
                    : _vm._e(),
                  _c("div", { staticClass: "card-number" }, [
                    _vm._v(_vm._s(_vm.cardBarcode)),
                  ]),
                  _c("div", { staticClass: "card-hint" }, [
                    _vm._v(_vm._s(_vm.$ct("card-hint"))),
                  ]),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }